module.exports = __webpack_public_path__ + "img/bg1.b9657325.webp";